<template>
  <div>
    <!-- 标题 -->
    <div class="instanceAli-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.region }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/elasticResourceAli">{{
          $t("alarms.elasticResource.elasticResource")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="instanceAli-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" filterable @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-if="isALY">
          <Select v-model="timeType" @on-change="changeTimeTypeALY(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="8"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : this.$route.query.accountTypeName == 'Aliyun'
          ? alyList
          : azureList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
export default {
  name: "instanceAli",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // AWS折线图
      awsList: [],
      // 阿里云折线图
      alyList: [
        {
          id: "netrxPkgsRate",
          title: this.$t("alarms.elasticResource.line.NetrxPkgsRate"),
        },
        {
          id: "nettxPkgsRate",
          title: this.$t("alarms.elasticResource.line.NettxPkgsRate"),
        },
        {
          id: "netrxRate",
          title: this.$t("alarms.elasticResource.line.NetrxRate"),
        },
        {
          id: "nettxRate",
          title: this.$t("alarms.elasticResource.line.NettxRate"),
        },
        {
          id: "netInRatePercentage",
          title: this.$t("alarms.elasticResource.line.NetInRatePercentage"),
        },
        {
          id: "netOutRatePercentage",
          title: this.$t("alarms.elasticResource.line.NetOutRatePercentage"),
        },
        {
          id: "outRateLimitDropSpeed",
          title: this.$t("alarms.elasticResource.line.OutRateLimitDropSpeed"),
        },
      ],
      isAWS: false,
      isALY: false,
      timeType: 0,
      timeList: [],
      id: "",
      accountId: "",
      accountTypeName: "",
      accountName: "",
      region: "",
      instanceId: "",
      monitorModule: "",
      // echarts实例
      netrxPkgsRateOptions: {},
      chartNetrxPkgsRate: "",
      nettxPkgsRateOptions: {},
      chartnettxPkgsRate: "",
      netrxRateOptions: {},
      nettxRateOptions: {},
      netInRatePercentageOptions: {},
      netOutRatePercentageOptions: {},
      outRateLimitDropSpeedOptions: {},
      chartNetrxRate: "",
      chartNettxRate: "",
      chartNetInRatePercentage: "",
      chartNetOutRatePercentage: "",
      chartOutRateLimitDropSpeed: "",
      //Aliyun数组
      netrxPkgsRate: [],
      nettxPkgsRate: [],
      netrxRate: [],
      nettxRate: [],
      netInRatePercentage: [],
      netOutRatePercentage: [],
      outRateLimitDropSpeed: [],
      readIOPS: [],
      writeIOPS: [],
      xaxisData: [],
    };
  },
  mounted: function () {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {});
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartNetrxPkgsRate.resize();
        self.chartNettxPkgsRate.resize();
        self.chartNetrxRate.resize();
        self.chartNettxRate.resize();
        self.chartNetInRatePercentage.resize();
        self.chartNetOutRatePercentage.resize();
        self.chartOutRateLimitDropSpeed.resize();
      });
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.checkMonitorModuleIndex();
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.checkAzureCloudVMDiskStatistics();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.checkALIEIPIndex();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          if (item.id == "netrxPkgsRate") {
            var optionFll = this.netrxPkgsRateOption;
          } else if (item.id == "nettxPkgsRate") {
            var optionFll = this.nettxPkgsRateOption;
          } else if (item.id == "netrxRate") {
            var optionFll = this.netrxRateOption;
          } else if (item.id == "nettxRate") {
            var optionFll = this.nettxRateOption;
          } else if (item.id == "netInRatePercentage") {
            var optionFll = this.netInRatePercentageOption;
          } else if (item.id == "netOutRatePercentage") {
            var optionFll = this.netOutRatePercentageOption;
          } else if (item.id == "outRateLimitDropSpeed") {
            var optionFll = this.outRateLimitDropSpeedOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },
    // Aliyun折线图
    checkALIEIPIndex: function () {
      this.$api.cloudWatch
        .checkALIEIPIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          region: this.$route.query.region,
          clusterIdentifier: this.$route.query.name,
          monitorModule: this.$route.query.monitorModule,
          instanceId: this.$route.query.allocationId,
        })
        .then((res) => {
          this.xaxisData = res.data.xaxisData;
          this.netrxPkgsRate = res.data.netrxPkgsRate;
          this.nettxPkgsRate = res.data.nettxPkgsRate;
          this.netrxRate = res.data.netrxRate;
          this.nettxRate = res.data.nettxRate;
          this.netInRatePercentage = res.data.netInRatePercentage;
          this.netOutRatePercentage = res.data.netOutRatePercentage;
          this.outRateLimitDropSpeed = res.data.outRateLimitDropSpeed;
          this.readIOPS = res.data.readIOPS;
          this.writeIOPS = res.data.writeIOPS;
          this.allAws();
        });
    },
    changeTimeType: function () {
      this.checkAWSEipStatistics();
    },
    changeTimeTypeALY: function () {
      this.checkALIEIPIndex();
    },
    /******************所有折线图********************************/
    allAws: function () {
      this.netrxPkgsRateLine();
      this.nettxPkgsRateLine();
      this.netrxRateLine();
      this.nettxRateLine();
      this.netInRatePercentageLine();
      this.netOutRatePercentageLine();
      this.outRateLimitDropSpeedLine();
    },
    /*************Aliyun折线图*****************************/
    //流入包速率
    netrxPkgsRateLine: function () {
      this.chartNetrxPkgsRate = this.$echarts.init(
        document.getElementById("netrxPkgsRate")
      );
      this.netrxPkgsRateOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 流入包速率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.elasticResource.line.NetrxPkgsRate")],
        },
        series: [
          {
            name: this.$t("alarms.elasticResource.line.NetrxPkgsRate"),
            type: "line",
            data: this.netrxPkgsRate,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetrxPkgsRate.setOption(this.netrxPkgsRateOption);
    }, //流出包速率
    nettxPkgsRateLine: function () {
      this.chartNettxPkgsRate = this.$echarts.init(
        document.getElementById("nettxPkgsRate")
      );
      this.nettxPkgsRateOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 流入包速率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.elasticResource.line.NettxPkgsRate")],
        },
        series: [
          {
            name: this.$t("alarms.elasticResource.line.NettxPkgsRate"),
            type: "line",
            data: this.nettxPkgsRate,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNettxPkgsRate.setOption(this.nettxPkgsRateOption);
    },
    //流入带宽
    netrxRateLine: function () {
      this.chartNetrxRate = this.$echarts.init(
        document.getElementById("netrxRate")
      );
      this.netrxRateOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 流入包速率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.elasticResource.line.NetrxRate")],
        },
        series: [
          {
            name: this.$t("alarms.elasticResource.line.NetrxRate"),
            type: "line",
            data: this.netrxRate,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetrxRate.setOption(this.netrxRateOption);
    },
    //流出带宽
    nettxRateLine: function () {
      this.chartNettxRate = this.$echarts.init(
        document.getElementById("nettxRate")
      );
      this.nettxRateOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 流入包速率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.elasticResource.line.NettxRate")],
        },
        series: [
          {
            name: this.$t("alarms.elasticResource.line.NettxRate"),
            type: "line",
            data: this.nettxRate,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNettxRate.setOption(this.nettxRateOption);
    },

    //网络流入带宽利用率
    netInRatePercentageLine: function () {
      this.chartNetInRatePercentage = this.$echarts.init(
        document.getElementById("netInRatePercentage")
      );
      this.netInRatePercentageOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 流入包速率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.elasticResource.line.NetInRatePercentage")],
        },
        series: [
          {
            name: this.$t("alarms.elasticResource.line.NetInRatePercentage"),
            type: "line",
            data: this.netInRatePercentage,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetInRatePercentage.setOption(this.netInRatePercentageOption);
    },
    //网络流出带宽利用率
    netOutRatePercentageLine: function () {
      this.chartNetOutRatePercentage = this.$echarts.init(
        document.getElementById("netOutRatePercentage")
      );
      this.netOutRatePercentageOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 流入包速率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.elasticResource.line.NetOutRatePercentage")],
        },
        series: [
          {
            name: this.$t("alarms.elasticResource.line.NetOutRatePercentage"),
            type: "line",
            data: this.netOutRatePercentage,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetOutRatePercentage.setOption(this.netOutRatePercentageOption);
    },

    //限速丢包速率
    outRateLimitDropSpeedLine: function () {
      this.chartOutRateLimitDropSpeed = this.$echarts.init(
        document.getElementById("outRateLimitDropSpeed")
      );
      this.outRateLimitDropSpeedOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 流入包速率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.elasticResource.line.OutRateLimitDropSpeed")],
        },
        series: [
          {
            name: this.$t("alarms.elasticResource.line.OutRateLimitDropSpeed"),
            type: "line",
            data: this.outRateLimitDropSpeed,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartOutRateLimitDropSpeed.setOption(
        this.outRateLimitDropSpeedOption
      );
    },
    /********************************/
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.instanceId = this.$route.query.instanceId;
      this.$router.push({
        path: "/monitor/elasticResourceDetailAli/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.instanceAli-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-8 {
  margin-bottom: 20px;
}
.instanceAli-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/eip/eip_dashboard/InstanceAli.vue